var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dummyInfo)?_c('div',{staticClass:"flex"},[_c('vs-alert',{attrs:{"active":"true","color":"danger"}},[_vm._v(_vm._s(_vm.dummyInfo))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }